import { Component, type ErrorInfo, type ReactNode } from 'react'
import { ErrorState } from '@/components/common/ErrorState'
import styles from './ErrorBoundary.module.css'

interface ErrorBoundaryProps {
  children: ReactNode
}

interface ErrorBoundaryState {
  error: Error | null
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { error: null }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    // Intentionally does not log tokens/PII — only the error boundary boundary message.
    console.error('SOC-Copilot render error:', error, info.componentStack)
  }

  private handleReset = () => {
    this.setState({ error: null })
  }

  render() {
    if (this.state.error) {
      return (
        <div className={styles.root}>
          <ErrorState
            title="A apărut o eroare neașteptată"
            detail={this.state.error.message || 'Reîncarcă pagina pentru a continua.'}
            onRetry={this.handleReset}
            retryLabel="Reîncearcă"
          />
        </div>
      )
    }

    return this.props.children
  }
}
